export default class {
    // @ngInject
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./activate/confirmation/confirmation-ctrl.js